import { jsx as t, jsxs as C, Fragment as W } from "react/jsx-runtime";
import { AlertGroup as en, Alert as tn, AlertVariant as Me, AlertActionCloseButton as nn, Page as rn, Modal as Ct, ModalVariant as an, TextContent as ln, Text as Le, Button as V, Spinner as kt, FormHelperText as He, HelperText as We, HelperTextItem as je, Popover as sn, Icon as Ne, FormGroup as It, NumberInput as on, ValidatedOptions as z, InputGroup as we, InputGroupItem as Be, TextInput as xe, Select as Se, SelectList as Te, SelectOption as Ge, MenuToggle as ue, MenuToggleStatus as ze, TextInputGroup as wt, TextInputGroupMain as xt, ChipGroup as Je, Chip as Ye, TextInputGroupUtilities as St, Switch as cn, TextArea as Tt, Title as dn, Card as un, CardHeader as hn, CardTitle as pn, CardBody as mn, Grid as fn, GridItem as st, PageSection as gn, JumpLinks as yn, JumpLinksItem as bn, ButtonVariant as ke, Checkbox as vn, Radio as Cn, MenuFooter as kn, Dropdown as In, DropdownList as wn, DropdownItem as ot, Masthead as xn, MastheadToggle as Sn, PageToggleButton as Tn, MastheadBrand as An, MastheadContent as En, Toolbar as Ce, ToolbarContent as Ve, ToolbarItem as H, Avatar as Rn, Bullseye as On, EmptyState as Dn, EmptyStateIcon as ct, EmptyStateHeader as Fn, EmptyStateBody as Pn, EmptyStateFooter as Mn, EmptyStateActions as Ln, SearchInput as Nn, Divider as Bn, Pagination as Vn, Badge as _n } from "@patternfly/react-core";
import { createContext as At, useContext as Et, useRef as J, useEffect as ae, useCallback as de, useState as E, useMemo as _, forwardRef as qn, useId as Rt, Fragment as Ot, Children as Dt, Component as $n, isValidElement as Un } from "react";
import { useTranslation as q } from "react-i18next";
import { NetworkError as Ft } from "@keycloak/keycloak-admin-client";
import Kn from "keycloak-js";
import { ExclamationCircleIcon as Hn, HelpIcon as dt, EyeIcon as Wn, EyeSlashIcon as jn, TimesIcon as Pt, CubeIcon as Gn, PaypalIcon as zn, InstagramIcon as Jn, BitbucketIcon as Yn, MicrosoftIcon as Qn, TwitterIcon as Xn, StackOverflowIcon as Zn, OpenshiftIcon as er, LinkedinIcon as tr, GoogleIcon as nr, GitlabIcon as rr, FacebookSquareIcon as ar, GithubIcon as lr, MinusCircleIcon as ir, PlusCircleIcon as Mt, EllipsisVIcon as sr, BarsIcon as or, SearchIcon as cr, SyncAltIcon as dr } from "@patternfly/react-icons";
import { useFormContext as Ae, Controller as le, useController as Qe, FormProvider as ur, useWatch as hr } from "react-hook-form";
import { get as B, cloneDeep as pr, intersectionBy as mr } from "lodash-es";
import ye from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as fr } from "@patternfly/react-styles";
import { Table as gr, TableVariant as yr, Thead as br, Tr as be, Th as Fe, Tbody as ut, Td as ne, ExpandableRowContent as vr, ActionsColumn as Cr, TableText as kr } from "@patternfly/react-table";
import './main.css';function Xe(e, n) {
  const r = At(n);
  return r.displayName = e, r;
}
const Ir = ["error", "errorMessage"], Pe = "error_description";
function wr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Ft)
    return Sr(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function xr(e) {
  if (!(e instanceof Ft))
    return;
  const n = e.responseData;
  return Lt(n);
}
function Lt(e) {
  if (typeof e == "object" && e !== null && Pe in e && typeof e[Pe] == "string")
    return e[Pe];
}
function Sr(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of Ir) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Tr = () => Math.floor(Math.random() * 1e3);
function Ar(e) {
  return e != null;
}
function Ze(e) {
  const n = Et(e);
  if (Ar(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Er() {
  const e = J(!1), n = J(/* @__PURE__ */ new Set());
  ae(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return de((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(s, l));
    n.current.add(i);
    function s() {
      n.current.delete(i), a();
    }
    return function() {
      clearTimeout(i), n.current.delete(i);
    };
  }, []);
}
function Rr({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    en,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: i }, s) => /* @__PURE__ */ t(
        tn,
        {
          "data-testid": s === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Me[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            nn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: i && /* @__PURE__ */ t("p", { children: i })
        },
        r
      ))
    }
  );
}
const Or = 8e3, Nt = Xe(
  "AlertContext",
  void 0
), Va = () => Ze(Nt), Dr = ({ children: e }) => {
  const { t: n } = q(), r = Er(), [a, l] = E([]), i = (d) => l((u) => u.filter((c) => c.id !== d)), s = de(
    (d, u = Me.success, c) => {
      const g = {
        id: Tr(),
        message: d,
        variant: u,
        description: c
      };
      l((y) => [g, ...y]), r(() => i(g.id), Or);
    },
    [r]
  ), o = de(
    (d, u) => {
      const c = n(d, { error: wr(u) }), g = xr(u);
      s(c, Me.danger, g);
    },
    [s, n]
  ), h = _(() => ({ addAlert: s, addError: o }), [s, o]);
  return /* @__PURE__ */ C(Nt.Provider, { value: h, children: [
    /* @__PURE__ */ t(Rr, { alerts: a, onCloseAlert: i }),
    e
  ] });
}, Fr = (e) => {
  const { t: n } = q(), r = e.error, a = Pr(r) || Lt(r)?.replace(/\+/g, " ");
  console.error(r);
  function l() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(rn, { children: /* @__PURE__ */ t(
    Ct,
    {
      variant: an.small,
      title: a ? "" : n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(V, { variant: "primary", onClick: l, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(ln, { children: a ? /* @__PURE__ */ t(Le, { children: n(a) }) : /* @__PURE__ */ t(Le, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Pr(e) {
  return typeof e == "string" ? e : e instanceof Error ? e.message : null;
}
function Mr(e, n, r) {
  const [a, l] = E(
    () => e.getItem(n) ?? r
  ), i = de((s) => {
    l(s), e.setItem(n, s);
  }, []);
  return ae(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", s);
    function s(o) {
      o.storageArea === e && (o.key === null || o.key === n) && l(o.newValue ?? r);
    }
    return () => window.removeEventListener("storage", s);
  }, [e, n]), [a, i];
}
function Bt(e, n, r) {
  const a = _(
    () => JSON.stringify(r),
    [r]
  ), [l, i] = Mr(
    e,
    n,
    a
  ), s = _(() => JSON.parse(l), [l]), o = de(
    (h) => i(JSON.stringify(h)),
    []
  );
  return [s, o];
}
const Vt = Xe(
  "HelpContext",
  void 0
), Lr = () => Ze(Vt), Nr = ({ children: e }) => {
  const [n, r] = Bt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Vt.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, Br = () => At(void 0);
let _e;
const _a = () => {
  const e = Et(_e);
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, qa = ({
  environment: e,
  children: n
}) => {
  _e = Br();
  const r = J(!1), [a, l] = E(!1), [i, s] = E(), o = _(() => {
    const d = new Kn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return d.onAuthLogout = () => d.login(), d;
  }, [e]);
  ae(() => {
    if (r.current)
      return;
    o.init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => l(!0)).catch((u) => s(u)), r.current = !0;
  }, [o]);
  const h = new URLSearchParams(window.location.search);
  return i || h.get("error_description") ? /* @__PURE__ */ t(
    Fr,
    {
      error: i || h.get("error_description")
    }
  ) : a ? /* @__PURE__ */ t(_e.Provider, { value: { environment: e, keycloak: o }, children: /* @__PURE__ */ t(Dr, { children: /* @__PURE__ */ t(Nr, { children: n }) }) }) : /* @__PURE__ */ t(kt, {});
};
function $a() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const Ua = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: i,
  buttonTestRole: s,
  onContinue: o,
  component: h = V,
  children: d,
  ...u
}) => {
  const [c, g] = E(!1);
  return /* @__PURE__ */ C(W, { children: [
    /* @__PURE__ */ t(
      h,
      {
        variant: i,
        onClick: () => g(!0),
        isDisabled: l,
        "data-testrole": s,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      Ct,
      {
        variant: "small",
        ...u,
        title: e,
        isOpen: c,
        onClose: () => g(!1),
        actions: [
          /* @__PURE__ */ t(
            V,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                g(!1), o();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            V,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => g(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: d
      }
    )
  ] });
}, _t = ({ message: e, ...n }) => /* @__PURE__ */ t(He, { ...n, children: /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { icon: /* @__PURE__ */ t(Hn, {}), variant: "error", children: e }) }) }), qt = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1
}) => {
  const { enabled: l } = Lr();
  return l ? /* @__PURE__ */ t(sn, { bodyContent: e, children: /* @__PURE__ */ C(W, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (i) => i.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(Ne, { isInline: r, children: /* @__PURE__ */ t(dt, {}) })
      }
    ),
    a && /* @__PURE__ */ t(Ne, { isInline: r, children: /* @__PURE__ */ t(dt, {}) })
  ] }) }) : null;
};
function he(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const te = ({
  name: e,
  label: n,
  labelIcon: r,
  error: a,
  children: l,
  ...i
}) => /* @__PURE__ */ C(
  It,
  {
    label: n || e,
    fieldId: e,
    labelIcon: r ? /* @__PURE__ */ t(qt, { helpText: r, fieldLabelId: e }) : void 0,
    ...i,
    children: [
      l,
      a && /* @__PURE__ */ t(_t, { "data-testid": `${e}-helper`, message: a.message })
    ]
  }
), Ka = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: i,
    formState: { errors: s }
  } = Ae();
  return /* @__PURE__ */ t(
    te,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: s[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        le,
        {
          ...r,
          name: e,
          control: i,
          render: ({ field: o }) => {
            const h = !!r.rules?.required, d = he(r.rules?.min), u = o.value ?? r.defaultValue, c = (g) => o.onChange(
              d !== void 0 ? Math.max(g, Number(d)) : g
            );
            return /* @__PURE__ */ t(
              on,
              {
                ...l,
                id: e,
                value: u,
                validated: s[e] ? z.error : z.default,
                required: h,
                min: Number(d),
                max: Number(r.rules?.max),
                onPlus: () => c(u + 1),
                onMinus: () => c(u - 1),
                onChange: (g) => {
                  const y = Number(g.currentTarget.value);
                  c(isNaN(y) ? r.defaultValue : y);
                }
              }
            );
          }
        }
      )
    }
  );
}, Vr = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = q(), [l, i] = E(!0);
  return /* @__PURE__ */ C(we, { children: [
    /* @__PURE__ */ t(Be, { isFill: !0, children: /* @__PURE__ */ t(
      xe,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      V,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => i(!l),
        children: l ? /* @__PURE__ */ t(Wn, {}) : /* @__PURE__ */ t(jn, {})
      }
    )
  ] });
}, $t = qn(
  (e, n) => /* @__PURE__ */ t(Vr, { ...e, innerRef: n })
);
$t.displayName = "PasswordInput";
const Ha = (e) => {
  const { labelIcon: n, ...r } = e, a = !!he(e.rules?.required), l = e.defaultValue ?? "", { field: i, fieldState: s } = Qe({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ C(
    te,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          $t,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: s.error ? z.error : z.default,
            isDisabled: e.isDisabled,
            ...r,
            ...i
          }
        ),
        e.helperText && /* @__PURE__ */ t(He, { children: /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { children: e.helperText }) }) })
      ]
    }
  );
}, _r = ({
  id: e,
  name: n,
  label: r,
  options: a,
  controller: l,
  labelIcon: i,
  isDisabled: s,
  onSelect: o,
  ...h
}) => {
  const {
    control: d,
    formState: { errors: u }
  } = Ae(), [c, g] = E(!1), y = he(l.rules?.required) === !0;
  return /* @__PURE__ */ t(
    te,
    {
      name: n,
      label: r,
      isRequired: y,
      error: B(u, n),
      labelIcon: i,
      children: /* @__PURE__ */ t(
        le,
        {
          ...l,
          name: n,
          control: d,
          render: ({ field: { onChange: v, value: x } }) => /* @__PURE__ */ t(
            Se,
            {
              ...h,
              variant: "default",
              onClick: () => g(!c),
              onOpenChange: () => g(!1),
              selected: Z(a) ? a.filter(
                (p) => Array.isArray(x) ? x.includes(p.key) : x === p.key
              ).map((p) => p.value) : x,
              toggle: (p) => /* @__PURE__ */ t(
                ue,
                {
                  id: e || n.slice(n.lastIndexOf(".") + 1),
                  ref: p,
                  onClick: () => g(!c),
                  isExpanded: c,
                  isFullWidth: !0,
                  status: B(u, n) ? ze.danger : void 0,
                  "aria-label": r,
                  isDisabled: s,
                  children: Z(a) ? a.find(
                    (m) => m.key === (Array.isArray(x) ? x[0] : x)
                  )?.value : x
                }
              ),
              onSelect: (p, m) => {
                const A = m?.toString(), T = Array.isArray(x) ? [A] : A;
                o ? o(T, v) : v(T), g(!1);
              },
              isOpen: c,
              children: /* @__PURE__ */ t(Te, { "data-testid": `select-${n}`, children: a.map((p) => /* @__PURE__ */ t(Ge, { value: re(p), children: et(p) ? p : p.value }, re(p))) })
            }
          )
        }
      )
    }
  );
}, ve = (e) => et(e) ? e : e.value, qr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  placeholderText: o,
  onFilter: h,
  variant: d,
  ...u
}) => {
  const {
    control: c,
    formState: { errors: g }
  } = Ae(), [y, v] = E(!1), [x, p] = E(""), [m, A] = E(0), [T, k] = E([]), b = J(), S = he(i.rules?.required) === !0, F = d === ce.typeaheadMulti, D = a.filter(
    (f) => ve(f).toLowerCase().startsWith(x.toLowerCase())
  ), N = _(
    () => D.map((f, w) => /* @__PURE__ */ t(
      Ge,
      {
        value: re(f),
        isFocused: m === w,
        children: ve(f)
      },
      re(f)
    )),
    [m, D]
  ), K = (f, w) => {
    w.value.includes(f) ? (w.onChange(w.value.filter((R) => R !== f)), Z(a) && k(
      T.filter((R) => R.key !== f)
    )) : (w.onChange([...w.value, f]), Z(a) && k([
      ...T,
      a.find((R) => R.key === f)
    ]));
  }, M = (f, w) => {
    const R = D[m];
    switch (v(!0), f.key) {
      case "Enter": {
        f.preventDefault(), p(F ? "" : ve(R)), K(re(R), w), v(!1), A(0);
        break;
      }
      case "Tab":
      case "Escape": {
        v(!1), w.onChange(void 0);
        break;
      }
      case "Backspace": {
        d === ce.typeahead && w.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        f.preventDefault();
        let O = 0;
        f.key === "ArrowUp" && (m === 0 ? O = a.length - 1 : O = m - 1), f.key === "ArrowDown" && (m === a.length - 1 ? O = 0 : O = m + 1), A(O);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    te,
    {
      name: n,
      label: r,
      isRequired: S,
      error: B(g, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        le,
        {
          ...i,
          name: n,
          control: c,
          render: ({ field: f }) => /* @__PURE__ */ t(
            Se,
            {
              ...u,
              onOpenChange: () => v(!1),
              selected: Z(a) ? a.filter(
                (w) => Array.isArray(f.value) ? f.value.includes(w.key) : f.value === w.key
              ).map((w) => w.value) : f.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (w) => /* @__PURE__ */ t(
                ue,
                {
                  ref: w,
                  id: e || n.slice(n.lastIndexOf(".") + 1),
                  variant: "typeahead",
                  onClick: () => {
                    v(!y), b.current?.focus();
                  },
                  isExpanded: y,
                  isFullWidth: !0,
                  status: B(g, n) ? ze.danger : void 0,
                  children: /* @__PURE__ */ C(wt, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      xt,
                      {
                        placeholder: o,
                        value: d === ce.typeahead && f.value ? Z(a) ? a.find(
                          (R) => R.key === (Array.isArray(f.value) ? f.value[0] : f.value)
                        )?.value : f.value : x,
                        onClick: () => v(!y),
                        onChange: (R, O) => {
                          p(O), h?.(O);
                        },
                        onKeyDown: (R) => M(R, f),
                        autoComplete: "off",
                        innerRef: b,
                        role: "combobox",
                        isExpanded: y,
                        "aria-controls": "select-typeahead-listbox",
                        children: d === ce.typeaheadMulti && Array.isArray(f.value) && /* @__PURE__ */ t(Je, { "aria-label": "Current selections", children: f.value.map(
                          (R, O) => /* @__PURE__ */ t(
                            Ye,
                            {
                              onClick: (ie) => {
                                ie.stopPropagation(), f.onChange(
                                  f.value.filter(
                                    ($) => $ !== re(R)
                                  )
                                );
                              },
                              children: Z(a) ? [
                                ...a,
                                ...T,
                                ...l
                              ].find((ie) => R === ie.key)?.value : ve(R)
                            },
                            O
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(St, { children: (!!x || f.value) && /* @__PURE__ */ t(
                      V,
                      {
                        variant: "plain",
                        onClick: () => {
                          p(""), f.onChange(F ? [] : ""), b?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Pt, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (w, R) => {
                w?.stopPropagation();
                const O = R?.toString();
                F && Array.isArray(f.value) ? (p(""), K(O || "", f)) : (f.onChange(Array.isArray(f.value) ? [O] : O), v(!1));
              },
              isOpen: y,
              children: /* @__PURE__ */ t(Te, { children: N })
            }
          )
        }
      )
    }
  );
};
var ce = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(ce || {});
const Z = (e) => typeof e[0] != "string", et = (e) => typeof e == "string", re = (e) => et(e) ? e : e.key, $r = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(_r, { ...n }) : /* @__PURE__ */ t(qr, { ...n, variant: e }), qe = (e) => e?.includes("${"), $e = (e) => e.substring(2, e.length - 1), ee = (e, n, r, a) => {
  const l = n || r, i = qe(l) ? $e(l) : l, s = a ? `${a}.${i}` : i;
  return e(s || "");
}, Ue = (e, n) => ee(e, n.displayName, n.name), Ur = ["username", "firstName", "lastName", "email"], Ut = (e) => e && Ur.includes(e), Y = (e) => `${Ut(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, Wa = (e) => e.replaceAll(".", "🍺"), Kr = (e) => e.replaceAll("🍺", ".");
function ja(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map((i) => qe(i?.toString()) ? r($e(i)) : i)
    );
    n(Y(a.field), {
      message: r(
        qe(a.errorMessage) ? $e(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function Ee({
  required: e
}) {
  return e;
}
function Ga(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ht(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ht);
}
function ht(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const za = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const s = r ?? (n ? "false" : !1), { control: o } = Ae();
  return /* @__PURE__ */ t(
    te,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        le,
        {
          control: o,
          name: l.name,
          defaultValue: s,
          render: ({ field: { onChange: h, value: d } }) => /* @__PURE__ */ t(
            cn,
            {
              ...l,
              id: l.name,
              "data-testid": Kr(l.name),
              label: e,
              isChecked: n ? d === "true" : d,
              onChange: (u, c) => {
                const g = n ? c.toString() : c;
                l.onChange?.(u, c), h(g);
              }
            }
          )
        }
      )
    }
  );
}, Ja = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = Qe({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    te,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        Tt,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? z.error : z.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, Ya = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!he(e.rules?.required), i = e.defaultValue ?? "", { field: s, fieldState: o } = Qe({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ C(
    te,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          xe,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: o.error ? z.error : z.default,
            isDisabled: e.isDisabled,
            ...a,
            ...s
          }
        ),
        r && /* @__PURE__ */ t(He, { children: /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { children: r }) }) })
      ]
    }
  );
}, Hr = Tt, Qa = ({ icon: e }) => {
  const n = Wr(e);
  return /* @__PURE__ */ t(Ne, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function Wr(e) {
  switch (e) {
    case "github":
      return lr;
    case "facebook":
      return ar;
    case "gitlab":
      return rr;
    case "google":
      return nr;
    case "linkedin":
    case "linkedin-openid-connect":
      return tr;
    case "openshift-v4":
      return er;
    case "stackoverflow":
      return Zn;
    case "twitter":
      return Xn;
    case "microsoft":
      return Qn;
    case "bitbucket":
      return Yn;
    case "instagram":
      return Jn;
    case "paypal":
      return zn;
    default:
      return Gn;
  }
}
const jr = "_title_180i0_2", Gr = {
  title: jr
}, Kt = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  dn,
  {
    headingLevel: r,
    size: a,
    className: Gr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), zr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = Rt();
  return /* @__PURE__ */ C(un, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(hn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(pn, { tabIndex: 0, children: /* @__PURE__ */ t(Kt, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(mn, { className: "kc-form-panel__body", children: n })
  ] });
}, Jr = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ C(W, { children: [
    /* @__PURE__ */ t(Kt, { id: a, title: n }),
    r
  ] }) });
}, Yr = "_panel_1cdve_1", Qr = "_sticky_1cdve_5", pt = {
  panel: Yr,
  sticky: Qr
}, Xr = "kc-main-content-page-container", mt = (e) => e.replace(/\s+/g, "-"), Zr = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = _(
    () => n.filter(({ isHidden: i }) => !i),
    [n]
  );
  return /* @__PURE__ */ C(fn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(st, { md: 8, sm: 12, children: l.map(({ title: i, panel: s }) => {
      const o = mt(i.toLowerCase());
      return /* @__PURE__ */ t(Ot, { children: r ? /* @__PURE__ */ t(
        zr,
        {
          scrollId: o,
          title: i,
          className: pt.panel,
          children: s
        }
      ) : /* @__PURE__ */ t(Jr, { scrollId: o, title: i, children: s }) }, i);
    }) }),
    /* @__PURE__ */ t(st, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(gn, { className: pt.sticky, children: /* @__PURE__ */ t(
      yn,
      {
        isVertical: !0,
        scrollableSelector: `#${Xr}`,
        label: e,
        offset: 100,
        children: l.map(({ title: i }) => {
          const s = mt(i.toLowerCase());
          return (
            // note that JumpLinks currently does not work with spaces in the href
            /* @__PURE__ */ t(
              bn,
              {
                href: `#${s}`,
                "data-testid": `jump-link-${s}`,
                children: i
              },
              i
            )
          );
        })
      }
    ) }) })
  ] });
}, ea = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, Xa = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...i
}) => /* @__PURE__ */ t(
  V,
  {
    variant: "primary",
    isDisabled: e && !ea(e, a, r) || n,
    ...i,
    type: "submit",
    children: l
  }
), ta = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, na = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = _(
    () => r.map((i) => ({
      key: i,
      value: e(`locale_${i}`, ta(i) ?? i)
    })).sort((i, s) => i.value.localeCompare(s.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(ur, { ...n, children: /* @__PURE__ */ t(
    $r,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, pe = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const i = ee(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: s }
  } = n, o = a?.(r), h = B(s, Y(r.name));
  return /* @__PURE__ */ C(
    It,
    {
      label: Ue(e, r) || "",
      fieldId: r.name,
      isRequired: Ee(r),
      labelIcon: i ? /* @__PURE__ */ t(qt, { helpText: i, fieldLabelId: r.name }) : void 0,
      children: [
        o ? /* @__PURE__ */ C(we, { children: [
          l,
          o
        ] }) : l,
        h && /* @__PURE__ */ t(
          _t,
          {
            "data-testid": `${r.name}-helper`,
            message: h.message
          }
        )
      ]
    },
    r.name
  );
}, ra = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(pe, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  aa,
  {
    t: e,
    form: n,
    "aria-label": Ue(e, r),
    name: Y(r.name),
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: Ue(e, r)
    }),
    ...l
  }
) }), aa = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: i = !1,
  defaultValue: s,
  id: o,
  ...h
}) => {
  const { register: d, setValue: u, control: c } = a, g = hr({
    name: n,
    control: c,
    defaultValue: s || ""
  }), y = _(() => Array.isArray(g) && g.length !== 0 ? g : s || [""], [g]), v = (T) => {
    m([...y.slice(0, T), ...y.slice(T + 1)]);
  }, x = () => {
    m([...y, ""]);
  }, p = (T, k) => {
    m([...y.slice(0, T), k, ...y.slice(T + 1)]);
  }, m = (T) => {
    const k = T.flatMap((b) => b);
    u(n, k, {
      shouldDirty: !0
    });
  }, A = r.startsWith("html") ? r.substring(6) : "text";
  return ae(() => {
    d(n);
  }, [d]), /* @__PURE__ */ t("div", { id: o, children: y.map((T, k) => /* @__PURE__ */ C(Ot, { children: [
    /* @__PURE__ */ C(we, { children: [
      /* @__PURE__ */ t(Be, { isFill: !0, children: /* @__PURE__ */ t(
        xe,
        {
          "data-testid": n + k,
          onChange: (b, S) => p(k, S),
          name: `${n}.${k}.value`,
          value: T,
          isDisabled: i,
          type: A,
          ...h
        }
      ) }),
      /* @__PURE__ */ t(Be, { children: /* @__PURE__ */ t(
        V,
        {
          "data-testid": "remove" + k,
          variant: ke.link,
          onClick: () => v(k),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: y.length === 1 || i,
          children: /* @__PURE__ */ t(ir, {})
        }
      ) })
    ] }),
    k === y.length - 1 && /* @__PURE__ */ C(
      V,
      {
        variant: ke.link,
        onClick: x,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !T || i,
        children: [
          /* @__PURE__ */ t(Mt, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, k)) });
}, ft = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Ee(a), i = r.startsWith("multiselect"), s = i ? vn : Cn, o = a.validators?.options?.options || [], h = a.annotations?.inputOptionLabels || {}, d = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    le,
    {
      name: Y(a.name),
      control: n.control,
      defaultValue: "",
      render: ({ field: u }) => /* @__PURE__ */ t(W, { children: o.map((c) => /* @__PURE__ */ t(
        s,
        {
          id: c,
          "data-testid": c,
          label: ee(e.t, h[c], c, d),
          value: c,
          isChecked: u.value.includes(c),
          onChange: () => {
            i ? u.value.includes(c) ? u.onChange(
              u.value.filter((g) => g !== c)
            ) : u.onChange([...u.value, c]) : u.onChange([c]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        c
      )) })
    }
  ) });
}, la = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: i,
  direction: s,
  width: o,
  maxHeight: h,
  toggleIcon: d,
  className: u,
  isDisabled: c,
  children: g,
  ...y
}) => {
  const [v, x] = E(!1), p = J(), m = () => {
    x(!v), n(!v);
  }, A = () => i === "parent" && p.current?.parentElement || "inline", T = Dt.toArray(
    g
  );
  return /* @__PURE__ */ t(
    Se,
    {
      ref: p,
      maxMenuHeight: Ie(h),
      isScrollable: !0,
      popperProps: {
        appendTo: A(),
        direction: s,
        width: Ie(o)
      },
      ...y,
      onClick: m,
      onOpenChange: (k) => {
        k !== v && m();
      },
      selected: a,
      onSelect: (k, b) => {
        r?.(b || ""), m();
      },
      toggle: (k) => /* @__PURE__ */ t(
        ue,
        {
          id: e,
          ref: k,
          className: u,
          onClick: m,
          isExpanded: l,
          "aria-label": y["aria-label"],
          icon: d,
          isDisabled: c,
          isFullWidth: !0,
          children: T.find((b) => b.props.value === a)?.props.children || a || y["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Te, { children: g })
    }
  );
}, ia = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  variant: l,
  validated: i,
  placeholderText: s,
  maxHeight: o,
  width: h,
  toggleIcon: d,
  direction: u,
  selections: c,
  typeAheadAriaLabel: g,
  chipGroupComponent: y,
  chipGroupProps: v,
  footer: x,
  isDisabled: p,
  children: m,
  ...A
}) => {
  const [T, k] = E(""), [b, S] = E(0), F = J(), D = Dt.toArray(
    m
  ), N = () => {
    r?.(!A.isOpen);
  }, K = (M) => {
    const f = D[b];
    switch (r?.(!0), M.key) {
      case "Enter": {
        M.preventDefault(), l !== G.typeaheadMulti ? k(f.props.value) : k(""), n?.(f.props.value), r?.(!1), S(0);
        break;
      }
      case "Escape": {
        r?.(!1);
        break;
      }
      case "Backspace": {
        l === G.typeahead && n?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        M.preventDefault();
        let w = 0;
        M.key === "ArrowUp" && (b === 0 ? w = D.length - 1 : w = b - 1), M.key === "ArrowDown" && (b === D.length - 1 ? w = 0 : w = b + 1), S(w);
        break;
      }
    }
  };
  return /* @__PURE__ */ C(
    Se,
    {
      ...A,
      onClick: N,
      onOpenChange: (M) => r?.(M),
      onSelect: (M, f) => {
        n?.(f || ""), a?.(""), k("");
      },
      maxMenuHeight: Ie(o),
      popperProps: { direction: u, width: Ie(h) },
      toggle: (M) => /* @__PURE__ */ t(
        ue,
        {
          ref: M,
          id: e,
          variant: "typeahead",
          onClick: () => r?.(!0),
          icon: d,
          isDisabled: p,
          isExpanded: A.isOpen,
          isFullWidth: !0,
          status: i === "error" ? ze.danger : void 0,
          children: /* @__PURE__ */ C(wt, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              xt,
              {
                placeholder: s,
                value: l === G.typeahead && c ? c : T,
                onClick: N,
                onChange: (f, w) => {
                  k(w), a?.(w);
                },
                onKeyDown: (f) => K(f),
                autoComplete: "off",
                innerRef: F,
                role: "combobox",
                isExpanded: A.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": g,
                children: l === G.typeaheadMulti && Array.isArray(c) && (y || /* @__PURE__ */ t(Je, { ...v, children: c.map((f, w) => /* @__PURE__ */ t(
                  Ye,
                  {
                    onClick: (R) => {
                      R.stopPropagation(), n?.(f);
                    },
                    children: f
                  },
                  w
                )) }))
              }
            ),
            /* @__PURE__ */ t(St, { children: !!T && /* @__PURE__ */ t(
              V,
              {
                variant: "plain",
                onClick: () => {
                  n?.(""), k(""), a?.(""), F?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Pt, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Te, { children: m }),
        x && /* @__PURE__ */ t(kn, { children: x })
      ]
    }
  );
};
var G = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(G || {});
const Ie = (e) => typeof e == "number" ? e + "px" : e, sa = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(la, { ...n }) : /* @__PURE__ */ t(ia, { ...n, variant: e }), gt = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [i, s] = E(!1), [o, h] = E(""), d = a === "multiselect", u = (p, m) => {
    d ? m.value.includes(p) ? m.onChange(m.value.filter((A) => A !== p)) : Array.isArray(m.value) ? m.onChange([...m.value, p]) : m.onChange([p]) : m.onChange(p === m.value ? "" : p);
  }, c = l.validators?.options?.options || [], g = l.annotations?.inputOptionLabels || {}, y = l.annotations?.inputOptionLabelsI18nPrefix, v = (p) => ee(e.t, g[p], p, y), x = (p) => c.filter(
    (m) => v(m).toLowerCase().includes(o.toLowerCase())
  ).map((m) => /* @__PURE__ */ t(
    Ge,
    {
      selected: p === m,
      value: m,
      children: v(m)
    },
    m
  ));
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    le,
    {
      name: Y(l.name),
      defaultValue: "",
      control: r.control,
      render: ({ field: p }) => /* @__PURE__ */ t(
        sa,
        {
          toggleId: l.name,
          onToggle: (m) => s(m),
          onClear: () => u("", p),
          onSelect: (m) => {
            const A = m.toString();
            u(A, p), Array.isArray(p.value) || s(!1);
          },
          selections: d && Array.isArray(p.value) ? p.value.map((m) => v(m)) : v(p.value),
          variant: d ? G.typeaheadMulti : c.length >= 10 ? G.typeahead : G.single,
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: l.readOnly,
          onFilter: (m) => (h(m), x(p.value)),
          children: x(p.value)
        }
      )
    }
  ) });
}, oa = (e) => {
  const { form: n, attribute: r } = e, a = Ee(r);
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    Hr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(Y(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a
    }
  ) });
}, U = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Ee(a), i = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    xe,
    {
      id: a.name,
      "data-testid": a.name,
      type: i,
      placeholder: a.readOnly ? "" : ee(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      ...n.register(Y(a.name))
    }
  ) });
}, Ke = {
  text: U,
  textarea: oa,
  select: gt,
  "select-radiobuttons": ft,
  multiselect: gt,
  "multiselect-checkboxes": ft,
  "html5-email": U,
  "html5-tel": U,
  "html5-url": U,
  "html5-number": U,
  "html5-range": U,
  "html5-datetime-local": U,
  "html5-date": U,
  "html5-month": U,
  "html5-time": U,
  "multi-input": ra
}, Za = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: i = !1,
  renderer: s
}) => {
  const o = _(() => {
    if (!r.attributes)
      return [];
    const h = i ? r.attributes.filter(({ readOnly: d }) => !d) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((d) => ({
      group: d,
      attributes: h.filter(
        (u) => u.group === d.name
      )
    }));
  }, [
    i,
    r.groups,
    r.attributes
  ]);
  return o.length === 0 ? null : /* @__PURE__ */ t(
    Zr,
    {
      label: e("jumpToSection"),
      sections: o.filter((h) => h.attributes.length > 0).map(({ group: h, attributes: d }) => ({
        title: ee(e, h.displayHeader, h.name) || e("general"),
        panel: /* @__PURE__ */ C("div", { className: "pf-v5-c-form", children: [
          h.displayDescription && /* @__PURE__ */ t(Le, { className: "pf-v5-u-pb-lg", children: ee(e, h.displayDescription, "") }),
          d.map((u) => /* @__PURE__ */ t(
            ca,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: s,
              attribute: u
            },
            u.name
          ))
        ] })
      }))
    }
  );
}, ca = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: i
}) => {
  const s = n.watch(
    Y(i.name)
  ), o = _(() => ua(i), [i]), h = i.multivalued || pa(s) && i.annotations?.inputType === void 0 ? Ke["multi-input"] : Ke[o];
  return i.name === "locale" ? /* @__PURE__ */ t(
    na,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: i
    }
  ) : /* @__PURE__ */ t(
    h,
    {
      t: e,
      form: n,
      inputType: o,
      attribute: i,
      renderer: r
    }
  );
}, da = "text";
function ua(e) {
  if (Ut(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return ha(n) ? n : da;
}
const ha = (e) => typeof e == "string" && e in Ke, pa = (e) => Array.isArray(e) && e.length > 1, ma = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: fr(
      ye.avatar,
      ye.modifiers[r],
      n === "light" && ye.modifiers.light,
      n === "dark" && ye.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ C("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), yt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, i] = E(!1);
  return /* @__PURE__ */ t(
    In,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (s) => i(s),
      toggle: (s) => /* @__PURE__ */ t(
        ue,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: s,
          onClick: () => i(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(sr, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(wn, { children: r })
    }
  );
};
function fa(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const el = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: i,
  features: {
    hasLogout: s = !0,
    hasManageAccount: o = !0,
    hasUsername: h = !0
  } = {},
  kebabDropdownItems: d,
  dropdownItems: u = [],
  toolbarItems: c,
  toolbar: g,
  ...y
}) => {
  const { t: v } = q(), x = [];
  o && x.push(
    /* @__PURE__ */ t(
      ot,
      {
        onClick: () => e.accountManagement(),
        children: v("manageAccount")
      },
      "manageAccount"
    )
  ), s && x.push(
    /* @__PURE__ */ t(ot, { onClick: () => e.logout(), children: v("signOut") }, "signOut")
  );
  const p = e.idTokenParsed?.picture;
  return /* @__PURE__ */ C(xn, { ...y, children: [
    /* @__PURE__ */ t(Sn, { children: /* @__PURE__ */ t(Tn, { variant: "plain", "aria-label": v("navigation"), children: /* @__PURE__ */ t(or, {}) }) }),
    /* @__PURE__ */ t(An, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ C(En, { children: [
      g,
      /* @__PURE__ */ t(Ce, { children: /* @__PURE__ */ C(Ve, { children: [
        c?.map((m, A) => /* @__PURE__ */ t(H, { align: { default: "alignRight" }, children: m }, A)),
        /* @__PURE__ */ t(
          H,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              yt,
              {
                "data-testid": "options",
                dropDownItems: [...u, x],
                title: h ? fa(e.idTokenParsed, v) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          H,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              yt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...d || u,
                  x
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          H,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: p || i?.src ? /* @__PURE__ */ t(Rn, { src: p, alt: v("avatar"), ...i }) : /* @__PURE__ */ t(ma, { ...i })
          }
        )
      ] }) })
    ] })
  ] });
}, Ht = Xe("ErrorBoundaryContext", void 0), Wt = () => Ze(Ht);
class tl extends $n {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Ht.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const nl = ({ children: e, fallback: n }) => {
  const { error: r } = Wt();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function ga(e, n, r) {
  const { showBoundary: a } = Wt();
  ae(() => {
    const l = new AbortController(), { signal: i } = l;
    return e().then((s) => {
      i.aborted || n(s);
    }).catch((s) => {
      console.error(s), i.aborted || a(s);
    }), () => l.abort();
  }, r);
}
const ya = () => {
  const { t: e } = q();
  return /* @__PURE__ */ t(On, { children: /* @__PURE__ */ t(kt, { "aria-label": e("spinnerLoading") }) });
}, ba = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: i,
  secondaryActions: s,
  icon: o,
  isDisabled: h = !1,
  children: d
}) => /* @__PURE__ */ C(Dn, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: cr }) : a && /* @__PURE__ */ t(ct, { icon: o || Mt }),
  /* @__PURE__ */ t(Fn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Pn, { children: n }),
  /* @__PURE__ */ C(Mn, { children: [
    i && /* @__PURE__ */ t(
      V,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: h,
        children: i
      }
    ),
    d,
    s && /* @__PURE__ */ t(Ln, { children: s.map((u) => /* @__PURE__ */ t(
      V,
      {
        "data-testid": `${u.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: u.type || ke.secondary,
        onClick: u.onClick,
        isDisabled: h,
        children: u.text
      },
      u.text
    )) })
  ] })
] }), va = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o
}) => {
  const { t: h } = q(), [d, u] = E(""), c = (y) => {
    u(y.trim()), o?.(y.trim());
  }, g = (y) => {
    y.key === "Enter" && c(d);
  };
  return /* @__PURE__ */ C(W, { children: [
    /* @__PURE__ */ t(Ce, { "data-testid": "table-toolbar", children: /* @__PURE__ */ C(Ve, { children: [
      i && /* @__PURE__ */ t(H, { children: /* @__PURE__ */ C(we, { "data-testid": i, children: [
        l,
        s && /* @__PURE__ */ t(
          Nn,
          {
            "data-testid": "table-search-input",
            placeholder: s,
            "aria-label": h("search"),
            value: d,
            onChange: (y, v) => {
              u(v);
            },
            onSearch: () => c(d),
            onKeyDown: g,
            onClear: () => c("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(Ce, { children: /* @__PURE__ */ t(Ve, { children: n }) }),
    /* @__PURE__ */ t(Bn, {}),
    a,
    /* @__PURE__ */ t(Ce, { children: r })
  ] });
}, bt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: i,
  onPreviousClick: s,
  onPerPageSelect: o
}) => {
  const { t: h } = q(), d = Math.round(a / l);
  return /* @__PURE__ */ t(
    Vn,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${h("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: u,
        lastIndex: c
      }) => /* @__PURE__ */ C("b", { children: [
        u,
        " - ",
        c
      ] }),
      itemCount: r + d * l,
      page: d + 1,
      perPage: l,
      onNextClick: (u, c) => i((c - 1) * l),
      onPreviousClick: (u, c) => s((c - 1) * l),
      onPerPageSelect: (u, c, g) => o(g - 1, c),
      variant: n
    }
  );
}, Ca = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o,
  ...h
}) => /* @__PURE__ */ t(
  va,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ C(W, { children: [
      r,
      /* @__PURE__ */ t(H, { variant: "pagination", children: /* @__PURE__ */ t(bt, { count: e, ...h }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(H, { variant: "pagination", children: /* @__PURE__ */ t(bt, { count: e, variant: "bottom", ...h }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: s,
    inputGroupOnEnter: o,
    children: l
  }
), jt = (e) => !!e && e.title !== void 0, vt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => {
  const l = r || a?.(e, {});
  return /* @__PURE__ */ C(W, { children: [
    e.cells.map((i, s) => /* @__PURE__ */ t(ne, { children: jt(i) ? i.title : i }, `cell-${s}`)),
    l && l.length > 0 && !e.disableActions && /* @__PURE__ */ t(ne, { isActionCell: !0, children: /* @__PURE__ */ t(Cr, { items: l, extraData: { rowIndex: n } }) })
  ] });
}, ka = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: jt(n) ? n.title : n }, `cell-${r}`));
function Ia({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: i,
  onSelect: s,
  onCollapse: o,
  canSelectAll: h,
  canSelect: d,
  isNotCompact: u,
  isRadio: c,
  ...g
}) {
  const { t: y } = q(), [v, x] = E(i || []), [p, m] = E([]), A = _(
    () => mr(
      v,
      n.map((b) => b.data),
      "id"
    ),
    [v, n]
  );
  ae(() => {
    if (h) {
      const b = document.getElementsByName("check-all").item(0);
      if (b) {
        const S = b;
        S.indeterminate = A.length < n.length && A.length > 0;
      }
    }
  }, [v, h, n]);
  const T = (b) => {
    x(b), s?.(b);
  }, k = (b, S) => {
    if (c) {
      const F = S ? [n[b].data] : [];
      T(F);
    } else if (b === -1) {
      const F = A.map(
        (D) => B(D, "id")
      );
      T(
        S ? [...v, ...n.map((D) => D.data)] : v.filter(
          (D) => !F.includes(B(D, "id"))
        )
      );
    } else
      T(S ? [...v, n[b].data] : v.filter(
        (F) => B(F, "id") !== n[b].data.id
      ));
  };
  return /* @__PURE__ */ C(
    gr,
    {
      ...g,
      variant: u ? void 0 : yr.compact,
      "aria-label": y(l),
      children: [
        /* @__PURE__ */ t(br, { children: /* @__PURE__ */ C(be, { children: [
          o && /* @__PURE__ */ t(Fe, { screenReaderText: y("expandRow") }),
          h && /* @__PURE__ */ t(
            Fe,
            {
              screenReaderText: y("selectAll"),
              select: c ? void 0 : {
                onSelect: (b, S) => {
                  k(-1, S);
                },
                isSelected: A.length === n.length
              }
            }
          ),
          e.map((b) => /* @__PURE__ */ t(
            Fe,
            {
              screenReaderText: y("expandRow"),
              className: b.transforms?.[0]().className,
              children: y(b.displayKey || b.name)
            },
            b.displayKey || b.name
          ))
        ] }) }),
        o ? n.map((b, S) => /* @__PURE__ */ t(ut, { children: S % 2 === 0 ? /* @__PURE__ */ C(be, { children: [
          /* @__PURE__ */ t(
            ne,
            {
              expand: n[S + 1].cells.length === 0 ? void 0 : {
                isExpanded: !!p[S],
                rowIndex: S,
                expandId: "expandable-row-",
                onToggle: (F, D, N) => {
                  o(N, D);
                  const K = [...p];
                  K[S] = N, m(K);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            vt,
            {
              row: b,
              index: S,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ C(be, { isExpanded: !!p[S - 1], children: [
          /* @__PURE__ */ t(ne, {}),
          /* @__PURE__ */ t(ne, { colSpan: e.length, children: /* @__PURE__ */ t(vr, { children: /* @__PURE__ */ t(ka, { row: b }) }) })
        ] }) }, S)) : /* @__PURE__ */ t(ut, { children: n.map((b, S) => /* @__PURE__ */ C(be, { isExpanded: p[S], children: [
          d && /* @__PURE__ */ t(
            ne,
            {
              select: {
                rowIndex: S,
                onSelect: (F, D, N) => {
                  k(N, D);
                },
                isSelected: !!v.find(
                  (F) => B(F, "id") === b.data.id
                ),
                variant: c ? "radio" : "checkbox",
                isDisabled: b.disableSelection
              }
            }
          ),
          /* @__PURE__ */ t(
            vt,
            {
              row: b,
              index: S,
              actions: r,
              actionResolver: a
            }
          )
        ] }, S)) })
      ]
    }
  );
}
function wa({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: i,
  isRadio: s,
  detailColumns: o,
  isRowDisabled: h,
  loader: d,
  columns: u,
  actions: c,
  actionResolver: g,
  searchTypeComponent: y,
  toolbarItem: v,
  subToolbar: x,
  emptyState: p,
  icon: m,
  isSearching: A = !1,
  ...T
}) {
  const { t: k } = q(), [b, S] = E([]), [F, D] = E(), [N, K] = E(), [M, f] = E(!1), [w, R] = Bt(
    localStorage,
    "pageSize",
    10
  ), [O, ie] = E(w), [$, se] = E(0), [j, Re] = E(""), tt = J(), [me, Gt] = E(0), nt = J(), rt = () => Gt(me + 1), zt = Rt(), at = (I, P) => I.map((L) => {
    if ("cellFormatters" in L) {
      const X = B(P, L.name);
      return L.cellFormatters?.reduce((oe, ge) => ge(oe), X);
    }
    if (L.cellRenderer) {
      const X = L.cellRenderer;
      return { title: /* @__PURE__ */ t(X, { ...P }) };
    }
    return B(P, L.name);
  }), lt = (I) => {
    const P = (L) => o?.[0]?.enabled?.(L);
    return I.map((L, X) => {
      const oe = h ? h(L) : !1, ge = [
        {
          data: L,
          disableSelection: oe,
          disableActions: oe,
          selected: !!b.find((Zt) => B(Zt, "id") === B(L, "id")),
          isOpen: P(L) ? !1 : void 0,
          cells: at(u, L)
        }
      ];
      return o && ge.push({
        parent: X * 2,
        cells: P(L) ? at(o, L) : []
      }), ge;
    }).flat();
  }, Oe = (I) => ["string", "number"].includes(typeof I) ? I.toString() : I instanceof Array ? I.map(Oe).join("") : typeof I == "object" ? Oe(
    Un(I.title) ? I.title.props : Object.values(I)
  ) : "", it = _(
    () => j === "" || r ? void 0 : lt(N || []).filter(
      (I) => I.cells.some(
        (P) => P && Oe(P).toLowerCase().includes(j.toLowerCase())
      )
    ).slice($, $ + O + 1),
    [j, $, O]
  );
  ga(
    async () => {
      f(!0);
      const I = tt.current === "" && j !== "";
      return I && se(0), tt.current = j, typeof d == "function" ? me === nt.current && N ? N : await d(I ? 0 : $, O + 1, j) : d;
    },
    (I) => {
      nt.current = me, r || (K(I), I.length > $ ? I = I.slice($, $ + O + 1) : se(0));
      const P = lt(I);
      D(P), f(!1);
    },
    [
      me,
      $,
      O,
      j,
      typeof d != "function" ? d : void 0
    ]
  );
  const Jt = () => c && pr(c).map((I, P) => (delete I.onRowClick, I.onClick = async (L, X) => {
    await c[P].onRowClick(
      (it || F)[X].data
    ) && (r || Re(""), rt());
  }, I)), Yt = (I, P) => {
    Q[P].isOpen = I, D([...Q]);
  }, Q = it || F, fe = !Q || Q.length === 0, De = j !== "" || A, Qt = o ? O * 2 : O, Xt = o ? (Q?.length || 0) / 2 : Q?.length || 0;
  return /* @__PURE__ */ C(W, { children: [
    (!fe || De) && /* @__PURE__ */ C(
      Ca,
      {
        id: zt,
        count: Xt,
        first: $,
        max: O,
        onNextClick: se,
        onPreviousClick: se,
        onPerPageSelect: (I, P) => {
          se(I), ie(P), R(P);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: Re,
        inputGroupPlaceholder: k(n || ""),
        searchTypeComponent: y,
        toolbarItem: /* @__PURE__ */ C(W, { children: [
          v,
          " ",
          /* @__PURE__ */ t(H, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(H, { children: /* @__PURE__ */ C(V, { variant: "link", onClick: rt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(dr, {}),
            " ",
            k("refresh")
          ] }) })
        ] }),
        subToolbar: x,
        children: [
          !M && !fe && /* @__PURE__ */ t(
            Ia,
            {
              ...T,
              canSelectAll: l,
              canSelect: !!a,
              selected: b,
              onSelect: (I) => {
                S(I), a?.(I);
              },
              onCollapse: o ? Yt : void 0,
              actions: Jt(),
              actionResolver: g,
              rows: Q.slice(0, Qt),
              columns: u,
              isNotCompact: i,
              isRadio: s,
              ariaLabelKey: e
            }
          ),
          !M && fe && De && /* @__PURE__ */ t(
            ba,
            {
              hasIcon: !0,
              icon: m,
              isSearchVariant: !0,
              message: k("noSearchResults"),
              instructions: k("noSearchResultsInstructions"),
              secondaryActions: A ? [] : [
                {
                  text: k("clearAllFilters"),
                  onClick: () => Re(""),
                  type: ke.link
                }
              ]
            }
          )
        ]
      }
    ),
    M && /* @__PURE__ */ t(ya, {}),
    !M && fe && !De && p
  ] });
}
const xa = ({ link: e, organization: n }) => {
  const { t: r } = q();
  return /* @__PURE__ */ t(kr, { wrapModifier: "truncate", children: /* @__PURE__ */ C(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      _n,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Sa = (e) => {
  const { t: n } = q();
  return /* @__PURE__ */ t(
    Je,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(Ye, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, rl = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: i,
  onDelete: s,
  deleteLabel: o = "delete",
  link: h,
  children: d
}) => {
  const { t: u } = q();
  return /* @__PURE__ */ t(
    wa,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: s ? [
        {
          title: u(o),
          onRowClick: s
        }
      ] : void 0,
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (c) => /* @__PURE__ */ t(xa, { link: h, organization: c })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Sa
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: d
    }
  );
};
export {
  Dr as AlertProvider,
  Ua as ContinueCancelModal,
  nl as ErrorBoundaryFallback,
  tl as ErrorBoundaryProvider,
  Fr as ErrorPage,
  _t as FormErrorText,
  zr as FormPanel,
  Xa as FormSubmitButton,
  Nr as Help,
  qt as HelpItem,
  Qa as IconMapper,
  wa as KeycloakDataTable,
  el as KeycloakMasthead,
  qa as KeycloakProvider,
  sa as KeycloakSelect,
  ya as KeycloakSpinner,
  Hr as KeycloakTextArea,
  ba as ListEmptyState,
  Ka as NumberControl,
  rl as OrganizationTable,
  Ca as PaginatingTableToolbar,
  Ha as PasswordControl,
  $t as PasswordInput,
  Zr as ScrollForm,
  $r as SelectControl,
  ce as SelectVariant,
  za as SwitchControl,
  va as TableToolbar,
  Ja as TextAreaControl,
  Ya as TextControl,
  Za as UserProfileFields,
  Wa as beerify,
  Xe as createNamedContext,
  Kr as debeerify,
  Tr as generateId,
  xr as getErrorDescription,
  wr as getErrorMessage,
  $a as getInjectedEnvironment,
  Lt as getNetworkErrorDescription,
  Sr as getNetworkErrorMessage,
  Ar as isDefined,
  Ga as isUserProfileError,
  ee as label,
  Xr as mainPageContentId,
  ja as setUserProfileServerError,
  Va as useAlerts,
  _a as useEnvironment,
  Wt as useErrorBoundary,
  ga as useFetch,
  Lr as useHelp,
  Ze as useRequiredContext,
  Er as useSetTimeout,
  Bt as useStoredState
};
